export const ERROR_TYPES = {
  GENERIC: 'GENERIC',
  NO_PACKAGES: 'NO_PACKAGES',
  NO_PACKAGES_WITH_FILTER: 'NO_PACKAGES_WITH_FILTER',
};
